import { TIKTOK_ACCOUNT_SUMMARY } from '../constants/actionTypes';

const INITIAL_STATE = { data: [], errors: null };

export default function tiktokSummary(state=INITIAL_STATE, action) {
 
  switch(action.type) {
    case TIKTOK_ACCOUNT_SUMMARY:
     
      // const parsedData = JSON.parse(action.payload.data)
     console.log("THE TIKTOK SUMMARY DATA IN REDUCER", (action.payload.data) )
      return { ...state, data: action.payload.data, errors: null };
      
    default:
      return state;
  }
}
